<div class="grid">
  <!-- Main Info Section (col-8) -->
  <div class="col-12 md:col-8">
    <h3 class="text-2xl font-semibold text-primary mb-3">My Profile</h3>

    <div class="section-card border-round p-4 position-relative shadow-1 surface-card">
      <!-- Show Edit Button only for staff -->
      <!-- <p-button *ngIf="!isGuardian" icon="pi pi-pencil" (click)="openDialog()" class="position-absolute edit-button"
        [ngStyle]="{ 'top': '15px', 'right': '15px', 'border-radius': '12px' }">
      </p-button> -->

      <div class="details-section grid gap-4">
        <!-- STAFF DATA DISPLAY -->
        <ng-container *ngIf="!isGuardian && staffData">
          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Name</div>
            <div class="section-content white-space-nowrap">{{ staffData.name || '-' }}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Email ID</div>
            <div class="section-content white-space-nowrap">{{ staffData.email || '-' }}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Phone Number</div>
            <div class="section-content white-space-nowrap">{{ staffData.phoneNumber ?? ''| changedPhoneNumber}}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Address</div>
            <div class="section-content white-space-nowrap">{{ staffData.address ?? ''}}</div>
          </div>
        </ng-container>

        <!-- GUARDIAN DATA DISPLAY -->
        <ng-container *ngIf="isGuardian && guardianData">
          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1"> Name</div>
            <div class="section-content white-space-nowrap">{{ guardianData.fullName || '-' }}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Relation</div>
            <div class="section-content white-space-nowrap">{{ studentRelation || '-' }}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Email ID</div>
            <div class="section-content white-space-nowrap">{{ guardianData.email || '-' }}</div>
          </div>

          <div class="section-group col-12 md:col-6">
            <div class="section-label font-medium text-900 mb-1">Contact</div>
            <div class="section-content white-space-nowrap">{{ guardianData.phoneNumber ?? '' | changedPhoneNumber }}
            </div>
          </div>
        </ng-container>

      </div>
    </div>

  </div>

  <!-- Profile Photo & Action Section (col-4) -->
  <div class="col-12 md:col-4">
    <div class="surface-card p-4 border-round shadow-1 text-center">
      <!-- STUDENT PROFILE -->
      <!-- ACTIVE STUDENT PROFILE -->
      <!-- GUARDIAN PROFILE -->
        <ng-container *ngIf="guardianData?.profileimg || guardianData?.fullName; else staffBlock">
          <div class="relative flex justify-content-center">
            <div class="image-container-wrapper position-relative">
              <ng-container *ngIf="guardianData.profileimg; else guardianInitials">
                <img [src]="guardianData.profileimg" alt="Profile" class="border-circle h-9rem w-9rem" />
              </ng-container>

              <ng-template #guardianInitials>
                <div
                  class="border-circle h-9rem w-9rem flex align-items-center justify-content-center text-white text-5xl font-bold"
                  [style.backgroundColor]="getBackgroundColor(guardianData.id)">
                  {{ getInitials(guardianData.fullName) }}
                </div>
              </ng-template>

              <!-- Edit/Delete Icon (Hidden by Default) -->
              <div class="edit-icon" *ngIf="isGuardian">
                <i *ngIf="!guardianData.photoUuid" class="pi pi-pencil"
                   style="color: rgb(247, 243, 243); font-size: 2rem;" 
                   (click)="showGuardianPhotoUploadDialog()"></i>
                <i *ngIf="guardianData.photoUuid" class="pi pi-trash" 
                   style="color: rgb(247, 243, 243); font-size: 2rem;" 
                   (click)="showGuardianDeletePhotoDialog()"></i>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- STAFF PROFILE FALLBACK -->
        <ng-template #staffBlock>
          <div class="flex justify-content-center">
            <!-- Avatar wrapper (controls dot positioning) -->
            <div class="relative" style="width: 125px; height: 125px;">
        
              <!-- Profile Image or Initials -->
              <ng-container *ngIf="staffData?.profileimg; else staffInitials">
                <img [src]="staffData.profileimg" alt="Profile" class="border-circle h-9rem w-9rem" />
              </ng-container>
        
              <ng-template #staffInitials>
                <div
                  class="border-circle h-9rem w-9rem flex align-items-center justify-content-center text-white text-5xl font-bold"
                  [style.backgroundColor]="getBackgroundColor(staffData.id)">
                  {{ getInitials(staffData.name) }}
                </div>
              </ng-template>
        
              <!-- Status Dot - properly positioned inside avatar wrapper -->
              <span
                class="absolute border-circle"
                [pTooltip]="getAttenStatus(staffData)"
                style="
                  top: 7px;
                  right: 16px;
                  width: 12px;
                  height: 12px;
                  border: 2px solid white;
                  z-index: 10;"
                [ngStyle]="{
                  'background-color':
                    staffData.isSignedIn ? '#00B115' :
                    staffData.isAbsent ? '#C82020' :
                    staffData.profileStatus == 'Upcoming' ? '#FDCD16' :
                    staffData.profileStatus == 'I' ? 'gray' : 'transparent'
                }"
                *ngIf="staffData.isSignedIn || staffData.isAbsent || staffData.profileStatus == 'Upcoming' || staffData.profileStatus == 'I'">
              </span>
            </div>
          </div>
        </ng-template>
        
        


      <div class="mt-3">
        <!-- STAFF PROFILE DISPLAY -->
        <ng-container *ngIf="!isStaffDataEmpty(); else guardianBlock">
          <div class="text-xl font-semibold text-900">
            {{ staffData.name || '-' }}
          </div>
          <div class="text-600 text-sm">{{ staffData.designation || '-' }}</div>
          <div *ngIf="staffRoomData; else noData" class="text-500 text-sm">
            {{ staffRoomData.name || '-' }}
          </div>

          <ng-template #noData>
            <div class="text-500 text-sm">-</div>
          </ng-template>
        </ng-container>
        <!-- GUARDIAN PROFILE DISPLAY (active student data) -->
        <ng-template #guardianBlock>
          <ng-container *ngIf="guardianData">
            <div class="text-xl font-semibold text-900">
              {{ guardianData.fullName || '-' }}
            </div>
            <!-- <div class="text-500 text-sm">
              {{ activeStudent.roomName || '-' }}
            </div> -->
          </ng-container>
        </ng-template>
      </div>

      <div class="mt-4 justify-content-center flex gap-3">
        <button pButton label="Switch Profile" class="p-button-outlined p-button-sm" [disabled]="!isAdditionalAccount"
          (click)="onSwitchProfile()"></button>

        <button pButton [label]="isGuardian ? 'View Student Profile' : 'View Staff Profile'"
          class="p-button-sm bg-primary text-white border-round" [disabled]="isGuardian && !activeStudentId"
          (click)="onViewProfile()"></button>

      </div>
    </div>
  </div>

</div>

<p-dialog header="Edit Guardian Profile" header="Edit Staff Profile" [(visible)]="showEditDialog" [modal]="true"
  [closable]="true" [style]="{ width: '600px' }">

  <div [formGroup]="staffForm" class="p-fluid">
    <div class="grid formgrid p-fluid">

      <!-- First Name -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="firstName" class="block text-sm mb-2 label" [appAsterisk]="true">First Name</label>
          <input id="firstName" type="text" pInputText formControlName="firstName" placeholder="Eg. John" appOnlyLetters
            class="w-full search-input" />
          <app-form-field-validation [control]="staffForm.get('firstName')!"></app-form-field-validation>
        </div>
      </div>

      <!-- Last Name -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="lastName" class="block text-sm mb-2 label" [appAsterisk]="true">Last Name</label>
          <input id="lastName" type="text" pInputText formControlName="lastName" placeholder="Eg. Doe" appOnlyLetters
            class="w-full search-input" />
          <app-form-field-validation [control]="staffForm.get('lastName')!"></app-form-field-validation>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="email" class="block text-sm mb-2 label" [appAsterisk]="true">Email</label>
          <input id="email" type="email" pInputText formControlName="email" placeholder="Eg. john.doe@example.com"
            class="w-full search-input" />
          <app-form-field-validation [control]="staffForm.get('email')!"></app-form-field-validation>
        </div>
      </div>

      <!-- Phone Number -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="phoneNumber" class="block text-sm mb-2 label" [appAsterisk]="true">Phone Number</label>
          <input id="phoneNumber" pInputText type="text" formControlName="phoneNumber" placeholder="Eg. (000) 000-0000"
            class="w-full search-input" appNumberParenthesesHyphenOnly [maxlength]="14"
            (input)="changeNumberMethod($event)" />
          <app-form-field-validation [control]="staffForm.get('phoneNumber')!"></app-form-field-validation>
        </div>
      </div>
    </div>

    <!-- Address Info -->
    <div class="mt-4" [formGroup]="addressForm">
      <h4>Address Information</h4>
      <div class="grid formgrid p-fluid">

        <!-- Street -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="street">Street</label>
            <input id="street" pInputText formControlName="street" placeholder="Eg. 123 Main St" />
          </div>
        </div>

        <!-- City -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="city">City</label>
            <input id="city" pInputText formControlName="city" placeholder="Eg. New York" />
          </div>
        </div>

        <!-- State -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="state">State</label>
            <input id="state" pInputText formControlName="state" placeholder="Eg. NY" />
          </div>
        </div>

        <!-- Country -->
        <div class="col-12 md:col-6">
          <div class="field">
            <label for="country">Country</label>
            <p-dropdown id="country" [options]="countries" formControlName="country" optionLabel="name"
              optionValue="name" placeholder="Select Country" class="custom-dropdown-filter"
              (onChange)="contiresSelectMethod($event)">
            </p-dropdown>
          </div>
        </div>

        <!-- ZIP -->
        <div class="col-12 md:col-4">
          <div class="field">
            <label for="zipcode">ZIP</label>
            <input id="zipcode" pInputText formControlName="zipcode" placeholder="Eg. 10001" />
          </div>
        </div>
      </div>
    </div>

    <!-- Save Button -->
    <div class="flex justify-content-end mt-4 gap-3">
      <!-- Cancel Button -->
      <button pButton type="button" label="Cancel"
              class="p-button-outlined p-button-secondary"
              (click)="onCancel()">
      </button>
    
      <!-- Save Button -->
      <button pButton type="button" label="Save"
              class="p-button-primary"
              (click)="onSubmit()">
      </button>
    </div>
    
  </div>
</p-dialog>

<!-- Guardian Photo Upload Dialog -->
<p-dialog header="Upload Profile Picture" [(visible)]="isUploadGuardianPhoto" [modal]="true" showEffect="face"
  [style]="{width: '50vw'}" [draggable]="false" [breakpoints]="{'960px': '90vw'}" (onHide)="closeGuardianPhotoUploadDialog()"
  [resizable]="false">
  <p-fileUpload [customUpload]="true" (uploadHandler)="onGuardianPhotoSelect($event)" accept="image/*"
    [showCancelButton]="false" [showUploadButton]="uploadButton" [maxFileSize]="10097152" #guardianUploader>
    <ng-template pTemplate="content">
    </ng-template>
  </p-fileUpload>
</p-dialog>

<!-- Guardian Photo Delete Dialog -->
<p-dialog header="Delete profile picture" [(visible)]="showDeleteGuardianPhotoDialog" [modal]="true" showEffect="fade"
  [style]="{ width: '30vw' }" (onHide)="closeGuardianDeletePhotoDialog()" [draggable]="false" [breakpoints]="{'960px': '80vw'}"
  [resizable]="false">
  <ng-template pTemplate="header">
    <span>Delete profile picture</span>
  </ng-template>
  <ng-template pTemplate="content">  
    <div class="flex flex-column icon-section align-items-center pt-5 pb-0">
      <div class="icon-circle flex flex-column align-items-center mb-3">
        <i class="wowlg wow-deletegroup"></i>
      </div>
      <div class="text-start">
        <p class="font-semibold text-base white-space-nowrap">{{ 'Do you want to delete this profile picture of- "' + guardianData.fullName + '"?' }}</p>    
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-center w-full gap-2">
      <button pButton pRipple type="button" id="Cancel" class="p-button p-button-primary p-button-outlined" 
        (click)="closeGuardianDeletePhotoDialog()" label="Cancel"></button>
      <p-button (onClick)="deleteGuardianPhoto()" label="Delete" id="delete"></p-button>
    </div>
  </ng-template>
</p-dialog>